// EXTERNAL
import { useHistory } from "react-router-dom";
import { useState } from "react"

// CSS
import "./FrontPage.css"

// COMPONENTS
import BigPrimaryButton from "../components/BigPrimaryButton.js"
import LabelledInputBox from "../components/LabelledInputBox.js"
import BrandingPanel from "../components/BrandingPanel.js";
import SubmitButton from "../components/SubmitButton.js"
import InfoBox from "../components/InfoBox.js";

/** 
 * This component renders the signup page.
 * 
 * @returns {ReactElement} A React element that renders the signup page. 
 */
export default function SignupPage({}) {
  const history = useHistory();
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [repassword, setRepassword] = useState("");

  const validatePassword = () => {
    if (password.length < 8) {
        setPopupMessage("Password must be at least 8 characters.");
        setShowPopup(true);
    } else if (/^\d+$/.test(password)) {
        setPopupMessage("Password cannot be entirely numeric.");
        setShowPopup(true);
    } else if (email && password.toLowerCase().includes(email.split('@')[0].toLowerCase())) {
        setPopupMessage("Password is too similar to your email.");
        setShowPopup(true);
    } else if (password !== repassword && repassword.length > 0) {
        setPopupMessage("Password fields must match.");
        setShowPopup(true);
    } else {
      setShowPopup(false);
    }
  };

  const handleSignUp = async (e) => {
    const userData = document.forms["Sign Up"].elements;

    const response = await fetch(`${process.env.REACT_APP_BACKEND_BASE_URL}/auth/users/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(
        {
          email: userData["Email"].value, 
          password: userData["Password"].value,
          re_password: userData["Confirm Password"].value,
          first_name: userData["First Name"].value,
          last_name: userData["Last Name"].value,
        }),
    })

    if (response.status == 201) {
      history.push("/login?reason=new-user")
    } else {
      const errorData = await response.json();
      setPopupMessage(Object.keys(errorData)[0] === "email" ? "User with this email already exists." : Object.values(errorData)[0].join("\n"));
      setShowPopup(true);
    }
  }

  return (
    <div className="front-page-body">
      <BrandingPanel></BrandingPanel>
      <div className="front-page-content">
        <InfoBox boxStyle="default" isVisible={showPopup} onClose={() => setShowPopup(false)}>{popupMessage}</InfoBox>
        <form className="front-page-form" name="Sign Up" action={handleSignUp}>
            <h2>Get Started with Aroa</h2>
            <div className="front-page-vertical-labelled-input-boxes">
            <LabelledInputBox label="Email" type="email" placeholder="Email" required={true} onChange={(e) => setEmail(e.target.value)}></LabelledInputBox>
            <LabelledInputBox label="Password" type="password" placeholder="Password" required={true} onChange={(e) => setPassword(e.target.value)} onBlur={validatePassword}></LabelledInputBox>
            <LabelledInputBox label="Confirm Password" type="password" placeholder="Confirm Password" required={true} onChange={(e) => setRepassword(e.target.value)} onBlur={validatePassword}></LabelledInputBox>
            </div>
            <div className="front-page-horizontal-labelled-input-boxes">
            <LabelledInputBox label="First Name" type="text" placeholder="First Name" required={true}></LabelledInputBox>
            <LabelledInputBox label="Last Name" type="text" placeholder="Last Name" required={true}></LabelledInputBox>
            </div>
            <div className="front-page-button-group">
            <SubmitButton buttonStyle="secondary">Sign Up</SubmitButton>
            </div>
            <div className="front-page-form-divider"></div>
            <div className="front-page-form-switch">
            <b>Already have an account?</b>
            <BigPrimaryButton buttonStyle="secondary" onClick={() => history.push("/login")}>Log In</BigPrimaryButton>
            </div>
        </form>
        <div className="copyright">{`© Korotu Technology ${process.env.REACT_APP_COPYRIGHT_YEAR}`}</div>
      </div>
    </div>
  )
}